/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_GENERATE_CLIENT_REQUEST,
  FETCH_GENERATE_CLIENT_SUCCESS,
  FETCH_GENERATE_CLIENT_FAILURE,
} from "./GenerateClientTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchGenerateClientRequest = () => {
  return {
    type: FETCH_GENERATE_CLIENT_REQUEST,
  };
};

export const fetchGenerateClientSuccess = (clientData) => {
  return {
    type: FETCH_GENERATE_CLIENT_SUCCESS,
    payload: clientData,
  };
};

export const fetchGenerateClientFailure = (error) => {
  return {
    type: FETCH_GENERATE_CLIENT_FAILURE,
    payload: error,
  };
};

export const fetchPostClient = (appId) => {
  return async function (dispatch) {
    dispatch(fetchGenerateClientRequest());
    try {
      const data = await APIManager.postGenerateClient(appId);
      dispatch(fetchGenerateClientSuccess(data));
    } catch (error) {
      dispatch(fetchGenerateClientFailure(error));
      dispatch(commonError(error, FETCH_GENERATE_CLIENT_FAILURE));
    }
  };
};

export const fetchGetClientIds = (applicationId) => {
  return async function (dispatch) {
    dispatch(fetchGenerateClientRequest());
    try {
      const data = await APIManager.getGenerateClient(applicationId);
        dispatch(fetchGenerateClientSuccess(data));
    } catch (error) {
      dispatch(fetchGenerateClientFailure(error));
      // Suppress error popup for getGenerateClient API call
      // dispatch(commonError(error,FETCH_GENERATE_CLIENT_FAILURE));
    }
  };
};

export const fetchDeleteClient = (clientId) => {
  return async function (dispatch) {
    dispatch(fetchGenerateClientRequest());
    try {
      const data = await APIManager.deleteGenerateClient(clientId);
      dispatch(fetchGenerateClientSuccess(data));
    } catch (error) {
      dispatch(fetchGenerateClientFailure(error));
      dispatch(commonError(error, FETCH_GENERATE_CLIENT_FAILURE));
    }
  };
};  

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}
